import { FOLLOWINGS, PROFILE_TABS } from "constants/index"
import { RootState } from "appRedux/store"
import { updateCloseFriends, updateUserProfile } from "appRedux/slices/userSlice"
import { updateViewedUserProfile } from "appRedux/slices/viewedUserSlice"
import { updateFollowingsTab, updateSelectedTabIndex } from "appRedux/slices/profileTabsSlice"

export async function handleOnCreateUnfollowRequestQueryStarted(followeeId: number, { dispatch, queryFulfilled, getState }: any) {
  try {
    const state = getState() as RootState
    const userProfile = state.user.profile
    if (!userProfile) return
    dispatch(updateUserProfile({
      ...userProfile,
      followingCount: userProfile.followingCount - 1
    }))

    const viewedProfile = state.viewedUser?.profile
    if (Number(followeeId) !== viewedProfile?.id) return
    const profileTabs = state.profileTabs
    const viewUserSelectedTabIndex = profileTabs?.selectedTabIndex?.[viewedProfile?.handle]
    if (viewUserSelectedTabIndex && viewUserSelectedTabIndex > 1) {
      dispatch(updateSelectedTabIndex({ handle: viewedProfile?.handle, index: 0 }))
    }
  } catch (error) {
    console.error(`Error creating unfollow request with followeeId: ${followeeId}:`, error)
  }
}

export async function handleOnAcceptFollowRequestQueryStarted(followerId: number, { dispatch, queryFulfilled, getState }: any) {
  try {
    const state = getState() as RootState
    const userProfile = state.user.profile
    if (userProfile) {
      dispatch(updateUserProfile({
        ...userProfile,
        followingCount: userProfile.followingCount + 1
      }))
    }

    const viewedProfile = state.viewedUser?.profile
    if (viewedProfile) {
      const profileTabs = state.profileTabs
      const viewUserSelectedTabIndex = profileTabs?.selectedTabIndex?.[viewedProfile?.handle]
      dispatch(updateViewedUserProfile({
        ...viewedProfile,
        followingCount: viewedProfile.followingCount + 1
      }))
      if (viewUserSelectedTabIndex === PROFILE_TABS[FOLLOWINGS]) {
        const followingsCpy = structuredClone(profileTabs.followings)
        followingsCpy.unshift({
          id: viewedProfile.id,
          handle: viewedProfile.handle,
          name: viewedProfile.name,
          avatar: viewedProfile.avatar,
          // @ts-ignore
          followStatus: viewedProfile.followStatus
        })
        dispatch(updateFollowingsTab(followingsCpy))
      }
    }
  } catch (error) {
    console.error(`Error accepting follow request with followerId: ${followerId}:`, error)
  }
}

export async function handleOnRemoveFollowerQueryStarted(followeeId: number, { dispatch, queryFulfilled, getState }: any) {
  try {
    const state = getState() as RootState
    const userProfile = state.user.profile
    if (!userProfile) return
    dispatch(updateUserProfile({
      ...userProfile,
      followerCount: userProfile.followerCount - 1
    }))
  } catch (error) {
    console.error(`Error removing follower with followeeId ${followeeId}:`, error)
  }
}

export async function handleOnGetCloseFriendsQueryStarted(arg: void, { dispatch, queryFulfilled, getState }: any) {
  try {
    const { data } = await queryFulfilled
    dispatch(updateCloseFriends(data.users))
  } catch (error) {
    console.error("Error getting close friends. Error:", error)
  }
}

export async function handleOnUpdateCloseFriendQueryStarted(id: number, { dispatch, queryFulfilled, getState }: any) {
  try {
    await queryFulfilled
    const state = getState() as RootState
    const viewedUserProfile = state.viewedUser?.profile
    if (viewedUserProfile?.id !== id) return
    dispatch(updateViewedUserProfile({
      ...viewedUserProfile,
      isCloseFriend: !viewedUserProfile.isCloseFriend
    }))
  } catch (error) {
    console.error(`Error adding user with id ${id} to close friends. Error:`, error)
  }
}
